import React from 'react';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #333;
  color: #fff;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 9997;
  box-sizing: border-box;
`;

const AppTitle = styled.h1`
  font-size: clamp(0.9rem, 3vw, 1.1rem);
  margin: 0;
  flex: 1;
  text-align: center;
`;

/* Hamburger: visible only on mobile */
const HamburgerButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 1.3rem;
  cursor: pointer;
  display: none;
  padding: 4px 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

/* Spacer keeps the title centred on desktop (matches HamburgerButton width) */
const Spacer = styled.div`
  width: 40px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = ({ onSidebarToggle, isSidebarOpen }) => {
  return (
    <HeaderWrapper>
      <HamburgerButton
        aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'}
        onClick={() => onSidebarToggle && onSidebarToggle(!isSidebarOpen)}
      >
        <FaBars />
      </HamburgerButton>

      <AppTitle>AdvPOS App</AppTitle>

      <Spacer />
    </HeaderWrapper>
  );
};

export default Header;
